import BpmnRenderer from "bpmn-js/lib/draw/BpmnRenderer";
import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import inherits from "inherits";
import { attr as svgAttr } from "tiny-svg";

function getBackgroundColor(element) {
  const bo = getBusinessObject(element);
  return bo.di.get("color:background-color");
}

export default function ColorRenderer(injector, eventBus) {
  // set higher priority then a default 1000 for an existing BpmnRenderer
  const callPriority = 2000;

  injector.invoke(BpmnRenderer, this);

  const self = this;

  eventBus.on(["render.shape"], callPriority, function (evt, context) {
    const element = context.element,
      visuals = context.gfx;

    // call default implementation
    const shape = self.drawShape(visuals, element);

    // 2D shape with default white color
    let colorFill = getBackgroundColor(element) || "#ffffff";
    if (element.type === "label") {
      colorFill = getBackgroundColor(element) || "#000000";
    }

    svgAttr(shape, {
      fill: colorFill,
    });

    // make sure default renderer is not called anymore
    return shape;
  });

  eventBus.on(["render.connection"], callPriority, function (evt, context) {
    const element = context.element,
      visuals = context.gfx;

    // call default implementation
    const shape = self.drawConnection(visuals, element);

    // line shape with default black color
    svgAttr(shape, {
      stroke: getBackgroundColor(element) || "#000000",
    });

    // make sure default renderer is not called anymore
    return shape;
  });
}

ColorRenderer.$inject = ["injector", "eventBus"];

inherits(ColorRenderer, BpmnRenderer);
